import { useFormat } from '@ideavivat/vivat-2';
import { purchase_request } from './base';

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    purchase_request,
    description: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    amount: {
      name: 'จำนวนที่ต้องการ / ซื้อแล้ว',
      width: '10rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: '',
      width: '5rem',
      class: 'text-left',
    },
    target_date: {
      name: 'กำหนดส่ง',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
  },
};
